import React from 'react';
import {Colors} from '../../styles/Colors';
import {GlobalStyleAttributes} from '../../styles/GlobalStyles';
import HStack from './Layout/HStack';
import VStack from './Layout/VStack';
import Box from './Layout/Box';
import AppText from './AppText';
import StepCircle from './StepCircle';

const InnerStepSection = (props) => {
    const {stepNumber, title, showConnector, headerExtra, children} = props;

    return (
    <HStack alignItems={'stretch'} space={'1rem'}>
        <VStack alignItems={'center'} style={{width: '24px', flexShrink: 0}}>
            <StepCircle stepNumber={stepNumber}/>
            {showConnector && (
                <Box flex={1} style={{width: '2px', backgroundColor: Colors.slotBorder, minHeight: '1.5rem', marginTop: '8px'}}/>
            )}
        </VStack>
        <VStack flex={1} style={{minWidth: 0, paddingBottom: showConnector ? '2rem' : 0}}>
            <HStack alignItems={'flex-start'} justifyContent={'space-between'} space={'1rem'} style={{width: '100%'}}>
                <AppText fontSize={GlobalStyleAttributes.fonts.heading18} color={Colors.newDesign.mainText}>
                    {title}
                </AppText>
                {headerExtra}
            </HStack>
            {children}
        </VStack>
    </HStack>
)};

export default InnerStepSection;
